export const TOGGLE_REGISTER_COMPANY = 'TOGGLE_REGISTER_COMPANY';
export const SUCCESS_SEND_EMAIL_REGISTER_COMPANY =
  'SUCCESS_SEND_EMAIL_REGISTER_COMPANY';
export const TOGGLE_SEND_EMAIL_CONTANT = 'TOGGLE_SEND_EMAIL_CONTANT';
export const START_REQUEST = 'START_REQUEST';
export const FINISH_REQUEST = 'FINISH_REQUEST';
export const VERIFY_EMAIL = 'VERIFY_EMAIL';
export const START_SIGNUP = 'START_SIGNUP';
export const PRE_LOGIN = 'PRE_LOGIN';
export const RESET_PRE_LOGIN = 'RESET_PRE_LOGIN';
export const REQUEST_FAILED = 'REQUEST_FAILED';
export const CLOSE_MODAL_ERROR = 'CLOSE_MODAL_ERROR';
export const SET_COMPANIES_TO_USER = 'SET_COMPANIES_TO_USER';
export const SELECT_COMPANY = 'SELECT_COMPANY';
export const SIGNUP_SET_REFERAL_FRIEND_CODE = 'SIGNUP_SET_REFERAL_FRIEND_CODE';
export const SIGNUP_SET_LINK_CODE = 'SIGNUP_SET_LINK_CODE';
export const REQUEST_SIGNUP_SUCCESSFUL = 'REQUEST_SIGNUP_SUCCESSFUL';
export const CLOSE_SIGNUP = 'CLOSE_SIGNUP';
export const CLOSE_EMAIL_CONFIRMATION = 'CLOSE_EMAIL_CONFIRMATION';
export const CLOSE_RESET_PASSWORD_MODAL_ERROR =
  'CLOSE_RESET_PASSWORD_MODAL_ERROR';
export const CLOSE_SENT_EMAIL_RESET_PASSWORD_MODAL =
  'CLOSE_SENT_EMAIL_RESET_PASSWORD_MODAL';
export const CHANGE_PASSWORD_SUCCESSFUL = 'CHANGE_PASSWORD_SUCCESSFUL';
export const REQUEST_SENT_EMAIL_RESET_PASSWORD_SUCCESS =
  'REQUEST_SENT_EMAIL_RESET_PASSWORD_SUCCESS';
export const REQUEST_SUCCESS_LOGIN = 'REQUEST_SUCCESS_LOGIN';
export const LOGOUT = 'LOGOUT';
export const FETCHING_BUSINESS_SUCCESS = 'FETCHING_BUSINESS_SUCCESS';
export const FETCHING_MENU_SUCCESS = 'FETCHING_MENU_SUCCESS';
export const SELECT_ITEM_SIDE_BAR_MENU = 'SELECT_ITEM_SIDE_BAR_MENU';
export const MENU_FETCHING_ADDRESS_SUCCESS = 'MENU_FETCHING_ADDRESS_SUCCESS';
export const MENU_SELECT_ADDRESS_FOR_ORDER = 'MENU_SELECT_ADDRESS_FOR_ORDER';
export const MENU_RESTAURANT_VERIFY_AVAILABLE_SUCCESSFUL =
  'MENU_RESTAURANT_VERIFY_AVAILABLE_SUCCESSFUL';
export const MENU_CHANGE_TITLE_HEADER = 'MENU_CHANGE_TITLE_HEADER';
export const MENU_REMOVE_RESTAURANT_NOT_AVAILABLE =
  'MENU_REMOVE_RESTAURANT_NOT_AVAILABLE';
export const MENU_HANDLE_ORDER_TO_REPEAT = 'MENU_HANDLE_ORDER_TO_REPEAT';
export const MENU_ERROR_HANDLING = 'MENU_ERROR_HANDLING';
export const MENU_RESET_STATE = 'MENU_RESET_STATE';
export const FETCHING_RECENTLY_ORDERED_SUCCESS =
  'FETCHING_RECENTLY_ORDERED_SUCCESS';
export const ORDER_FEEDBACK_PENDING_SUCCESS = 'ORDER_FEEDBACK_PENDING_SUCCESS';
export const ORDER_FEEDBACK_CLEAR = 'ORDER_FEEDBACK_CLEAR';
export const ORDER_FEEDBACK_SUBMITTED = 'ORDER_FEEDBACK_SUBMITTED';
export const ORDER_FEEDBACK_SKIPPED = 'ORDER_FEEDBACK_SKIPPED';
export const START_RECENTLY_ORDER_REQUEST = 'START_RECENTLY_ORDER_REQUEST';
export const FINISH_RECENTLY_ORDER_REQUEST = 'FINISH_RECENTLY_ORDER_REQUEST';
export const FETCHING_PRODUCT_SUCCESS = 'FETCHING_PRODUCT_SUCCESS';
export const DELETE_RESTAURANT_SELECTED = 'DELETE_RESTAURANT_SELECTED';
export const RESTAURANT_SELECTED = 'RESTAURANT_SELECTED';
export const CATEGORIES_SELECTED = 'CATEGORIES_SELECTED';
export const SETTING_ACTIVE_CATEGORY = 'SETTING_ACTIVE_CATEGORY';
export const SELECT_PRODUCT = 'SELECT_PRODUCT';
export const SELECT_PRODUCT_TO_CART = 'SELECT_PRODUCT_TO_CART';
export const CLOSE_PRODUCT_DETAILS = 'CLOSE_PRODUCT_DETAILS';
export const TOGGLE_CART = 'TOGGLE_CART';
export const TOGGLE_MENU_MOBILE = 'TOGGLE_MENU_MOBILE';
export const TOGGLE_RESTAURANTS_MOBILE = 'TOGGLE_RESTAURANTS_MOBILE';
export const ADD_PRODUCT_TO_CART = 'ADD_PRODUCT_TO_CART';
export const DELETE_PRODUCT_FROM_CART = 'DELETE_PRODUCT_FROM_CART';
export const DELETE_ALL_PRODUCTS_FROM_CART = 'DELETE_ALL_PRODUCTS_FROM_CART';
export const CART_SET_PAY_INFO = 'CART_SET_PAY_INFO';

export const CHANGE_RESTAURANT_OPTIONS = 'CHANGE_RESTAURANT_OPTIONS';
export const USER_LOGGING_IN = 'USER_LOGGING_IN';
export const USER_LOGGING_OUT = 'USER_LOGGING_OUT';
export const REALEX_CONFIG_DATA_LOADED = 'REALEX_CONFIG_DATA_LOADED';
export const STRIPE_CONFIG_DATA_LOADED = 'STRIPE_CONFIG_DATA_LOADED';
export const CHECKOUT_REALEX_TOGGLE_SHOW_MODAL_RECEIPT =
  'CHECKOUT_REALEX_TOGGLE_SHOW_MODAL_RECEIPT';
export const CHECKOUT_REALEX_TOGGLE_SHOW_MODAL_PLACE_ORDER =
  'CHECKOUT_REALEX_TOGGLE_SHOW_MODAL_PLACE_ORDER';
export const CHECKOUT_REALEX_TOGGLE_SHOW_MODAL_ERROR =
  'CHECKOUT_REALEX_TOGGLE_SHOW_MODAL_ERROR';
export const SUCCESS_FETCHING_CARDS = 'SUCCESS_FETCHING_CARDS';
export const SUCCESS_FETCHING_CAMPAIGN_RATE = 'SUCCESS_FETCHING_CAMPAIGN_RATE';
export const TRIGGER_MODAL_ERROR_PLACED_ORDER =
  'TRIGGER_MODAL_ERROR_PLACED_ORDER';
export const SUCCESS_PLACE_ORDER = 'SUCCESS_PLACE_ORDER';
export const CLOSE_MODAL_ERROR_LIMIT = 'CLOSE_MODAL_ERROR_LIMIT';
export const CLOSE_MODAL_ERROR_PLACED_ORDER = 'CLOSE_MODAL_PLACED_ORDER';
export const CART_CALCULATED_VALUES = 'CART_CALCULATED_VALUES';
export const CART_UPDATED_RESTAURANT_STATUS = 'CART_UPDATED_RESTAURANT_STATUS';
export const CART_TOGGLE_SHOW_MODAL_PLACE_ORDER =
  'CART_TOGGLE_SHOW_MODAL_PLACE_ORDER';
export const CART_TOGGLE_SHOW_MODAL_RECEIPT = 'CART_TOGGLE_SHOW_MODAL_RECEIPT';
export const CART_SET_PLACED_BUTTON_DISABLED =
  'CART_SET_PLACED_BUTTON_DISABLED';
export const CART_SET_INVOICE = 'CART_SET_INVOICE';
export const CART_RESET_STATE = 'CART_RESET_STATE';
export const CART_DELIVERY_TOMORROW = 'CART_DELIVERY_TOMORROW';
export const CHECKOUT_RESET_STATE = 'CHECKOUT_RESET_STATE';
export const CHECKOUT_RESIZE_REALEX_FORM = 'CHECKOUT_RESIZE_REALEX_FORM';
export const CHECKOUT_SET_INTERVAL_REFERENCE =
  'CHECKOUT_SET_INTERVAL_REFERENCE';
export const SETTINGS_SHOW_CHANGE_COMPANY = 'SETTINGS_SHOW_CHANGE_COMPANY';
export const SETTINGS_CLOSE_CHANGE_COMPANY = 'SETTINGS_CLOSE_CHANGE_COMPANY';
export const SETTINGS_SEND_EMAIL_SUPPORT_SUCCESS =
  'SETTINGS_SEND_EMAIL_SUPPORT_SUCCESS';
export const SETTINGS_CLOSE_SENT_EMAIL_SUPORT =
  'SETTINGS_CLOSE_SENT_EMAIL_SUPORT';
export const SETTINGS_UNSUBSCRIBE_SUCCESS = 'SETTINGS_UNSUBSCRIBE_SUCCESS';
export const SETTINGS_SHOW_ERROR_UNSUBSCRIBE =
  'SETTINGS_SHOW_ERROR_UNSUBSCRIBE';
export const SETTINGS_CLOSE_ERROR_UNSUBSCRIBE =
  'SETTINGS_CLOSE_ERROR_UNSUBSCRIBE';
export const SETTINGS_ACCOUNT_DELETED = 'SETTINGS_ACCOUNT_DELETED';
export const TEAM_VOUCHER_SUCCESS_FETCHING_CARDS =
  'TEAM_VOUCHER_SUCCESS_FETCHING_CARDS';
export const TEAM_VOUCHER_SUCCESS_PLACE_ORDER =
  'TEAM_VOUCHER_SUCCESS_PLACE_ORDER';
export const TEAM_VOUCHER_RESET_STATE = 'TEAM_VOUCHER_RESET_STATE';
export const TEAM_VOUCHER_TOGGLE_SHOW_MODAL_PLACE_ORDER =
  'TEAM_VOUCHER_TOGGLE_SHOW_MODAL_PLACE_ORDER';
export const TEAM_VOUCHER_TOGGLE_SHOW_MODAL_RECEIPT =
  'TEAM_VOUCHER_TOGGLE_SHOW_MODAL_RECEIPT';
export const TEAM_VOUCHER_SHOW_MODAL_CONFIRM_EMAILS =
  'TEAM_VOUCHER_TOGGLE_SHOW_MODAL_CONFIRM_EMAILS';
export const TEAM_VOUCHER_CLOSE_MODAL_CONFIRM_EMAILS =
  'TEAM_VOUCHER_TOGGLE_CLOSE_MODAL_CONFIRM_EMAILS';
export const TEAM_VOUCHER_OPEN_MODAL_ERROR = 'TEAM_VOUCHER_OPEN_MODAL_ERROR';
export const TEAM_VOUCHER_CLOSE_MODAL_ERROR = 'TEAM_VOUCHER_CLOSE_MODAL_ERROR';
export const TEAM_VOUCHER_SET_ORDER = 'TEAM_VOUCHER_SET_ORDER';
export const TEAM_VOUCHER_SET_AVAILABLE_TEAM_VOUCHER =
  'TEAM_VOUCHER_SET_AVAILABLE_TEAM_VOUCHER';
export const TEAM_VOUCHER_SET_CAMPAIGN_RATE = 'TEAM_VOUCHER_SET_CAMPAIGN_RATE';
export const TEAM_VOUCHER_SET_PAY_INFO = 'TEAM_VOUCHER_SET_PAY_INFO';
export const VOUCHER_BALANCE_SUCCESS = 'VOUCHER_BALANCE_SUCCESS';
export const GET_ORDERS_DELIVERY_TRACKING_SUCCESS =
  'GET_ORDERS_DELIVERY_TRACKING_SUCCESS';
export const GDPR_SUCCESS_PRIVACY_POLICY = 'GDPR_SUCCESS_PRIVACY_POLICY';
export const GDPR_SUCCESS_TERMS_CONDITIONS = 'GDPR_SUCCESS_TERMS_CONDITIONS';
export const GDPR_LOAD_STARTED = 'GDPR_LOAD_STARTED';
export const GDPR_LOAD_FAILED = 'GDPR_LOAD_FAILED';
export const TAGGED_INPUT_TEXT_ADD = 'TAGGED_INPUT_TEXT_ADD';
export const TAGGED_INPUT_TEXT_REMOVE = 'TAGGED_INPUT_TEXT_REMOVE';
export const TAGGED_INPUT_TEXT_VALID_VALUE = 'TAGGED_INPUT_TEXT_VALID_VALUE';
export const TAGGED_INPUT_TEXT_INVALID_VALUE =
  'TAGGED_INPUT_TEXT_INVALID_VALUE';
export const TAGGED_INPUT_TEXT_RESET = 'TAGGED_INPUT_TEXT_RESET';
export const TAGGED_INPUT_TEXT_SET_VALUE = 'TAGGED_INPUT_TEXT_SET_VALUE';
export const INVOICE_FETCHING_SUCCESS = 'INVOICE_FETCHING_SUCCESS';
export const INVOICE_PAY_SUCCESS = 'INVOICE_PAY_SUCCESS';
export const INVOICE_RESET_STATE = 'INVOICE_RESET_STATE';
export const LINK_VOUCHER_CREATE = 'LINK_VOUCHER_CREATE';
export const REQUEST_SUCCESS_CREATE_VOUCHER = 'REQUEST_SUCCESS_CREATE_VOUCHER';
export const REQUEST_FAILED_CREATE_VOUCHER = 'REQUEST_FAILED_CREATE_VOUCHER';
export const CLOSE_MODAL_ERROR_CREATE_LINK_VOUCHER =
  'CLOSE_MODAL_ERROR_CREATE_LINK_VOUCHER';
export const CLOSE_MODAL_SUCCESS_CREATE_LINK_VOUCHER =
  'CLOSE_MODAL_SUCCESS_CREATE_LINK_VOUCHER';
export const LINK_VOUCHER_LOAD = 'LINK_VOUCHER_LOAD';

export const CREATED_NEW_CUSTOMER_DELIVERY_ADDRESS =
  'CREATED_NEW_CUSTOMER_DELIVERY_ADDRESS';

// Guest ordering: "Who's this for?"
export const GUEST_POLICY_LOADED = 'GUEST_POLICY_LOADED';
export const GUEST_RECIPIENT_ASK = 'GUEST_RECIPIENT_ASK';
export const GUEST_RECIPIENT_CANCEL = 'GUEST_RECIPIENT_CANCEL';
export const GUEST_ADDED_TO_BASKET = 'GUEST_ADDED_TO_BASKET';
export const GUEST_RECIPIENT_CHOSEN = 'GUEST_RECIPIENT_CHOSEN';
export const GUEST_CHECKOUT_KEY_SPENT = 'GUEST_CHECKOUT_KEY_SPENT';
export const CART_PARTY_VALUES = 'CART_PARTY_VALUES';
export const CART_REMOVE_PARTIES = 'CART_REMOVE_PARTIES';
export const CART_BATCH_RESULT = 'CART_BATCH_RESULT';
export const CART_BATCH_RESULT_CLOSE = 'CART_BATCH_RESULT_CLOSE';



// WEBPACK FOOTER //
// ./src/store/actions/actionTypes.js